import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('serviceLogHistory');

    return {
        NO_SERVICE_LOGGED: t('noServiceLogged')
    };
};

export default useTranslation;
